const Quantity = ({ quantity }) => {
  return (
    <p>
      Qty: <span className="quantity">{quantity}</span>
    </p>
  );
};

export default Quantity;
